module.exports = __webpack_public_path__ + "media/video-play-button.90faa221.svg";